/* unplugin-vue-components disabled */import script from "./AndroidVersion.vue?vue&type=script&setup=true&name=AndroidVersion&lang=js"
export * from "./AndroidVersion.vue?vue&type=script&setup=true&name=AndroidVersion&lang=js"

import "./AndroidVersion.vue?vue&type=style&index=0&id=3bc0ebcc&lang=scss&scoped=true"

import exportComponent from "E:\\new-admin\\3.0\\ruoyi-vue3-cli\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3bc0ebcc"]])

export default __exports__